'use client'

import { Branch } from '@/types/branch'
import { useEffect, useState, useTransition } from 'react'
import { fetchJobsAction } from '@/features/jobs/action'
import { ESJob } from '@/types/job'
import JobItem from '@/features/jobs/components/JobItem'
import { Center, Spinner } from '@chakra-ui/react'
import { useCurrentPage } from '@/hooks/useCurrentPage'
import Pagination from '@/components/Pagination'
import { EmptyState } from '@/components/EmptyState'

type Props = {
  branch: Branch
  setTotal: (total: number) => void
}

export const BranchJobs = ({ branch, setTotal }: Props) => {
  const [jobs, setJobs] = useState<ESJob[]>([])
  const [isPending, startTransition] = useTransition()
  const { currentPage, setCurrentPage } = useCurrentPage()
  const PER_PAGE = 10

  // ダサい変数名
  const [totalAndOffset, setTotalAndOffset] = useState<{
    total: number
    offset: number
  }>({
    total: 0,
    offset: 0,
  })

  const fetchJobs = () => {
    startTransition(() => {
      fetchJobsAction({ 'branch_ids[]': branch.id, page: currentPage(), limit: PER_PAGE, sort: 'newest' })
        .then((res) => {
          if (!res.ok) return
          setJobs(res.payload)
          if (res.headers) {
            setTotal(res.headers?.totalItems)
            setTotalAndOffset({
              total: res.headers!.totalItems,
              offset: res.payload.length + (currentPage() - 1) * PER_PAGE,
            })
          }
        })
        .catch((_e) => {})
    })
  }

  useEffect(() => {
    fetchJobs()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentPage()])

  return (
    <>
      {isPending ? (
        <Center mt={'130px'}>
          <Spinner thickness="4px" speed="0.65s" emptyColor="gray.100" color="primary.500" size="xl" />
        </Center>
      ) : (
        <>
          {jobs.length === 0 ? (
            <EmptyState mt={10} title="募集はありません" description={''} />
          ) : (
            <>
              {jobs.map((job) => {
                return <JobItem key={job.id} job={job} />
              })}
              <Center mx={'auto'} mb={'5'}>
                <Pagination
                  onChange={({ page }) => setCurrentPage(`companies/${branch.id}`, page)}
                  per={PER_PAGE}
                  currentPage={currentPage()}
                  sum={totalAndOffset.total}
                />
              </Center>
            </>
          )}
        </>
      )}
    </>
  )
}
